export default function() {
  const widgetName = 'cardWidgetMegaRidePass';
  const widgetOpts = cardWidgetMegaRidePassOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      if ($('body').hasClass('homepage')) {
        $('.t4-bg-d').css('background-image', `url('${data.items[1].ImageWithPath}')`);
        $('.t4-bg-m').css('background-image', `url('${data.items[2].ImageWithPath}')`);
        $(`#${widgetName} .card-widget-item`).first().prepend(`<div class="m-bg" style="background-image: url('${data.items[2].ImageWithPath}')"></div>`);
      }

      $(`#${widgetName} .buttonwrap a`).text(data.items[0].DetailLinkText);
      

      // add animate.css classes
      let target = document.getElementById(`${widgetName}`);
      if (!$('body').hasClass('homepage')) {
        target = document.querySelector(`#${widgetName} .card-widget-item`);
      }
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: [0.5],
      };
      let callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.5) {
            $(entry.target).addClass('animate__animated animate__fadeInUp');
          }
        });
      };
      let observer = new IntersectionObserver(callback, options);
      observer.observe(target);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: true,
      text: 'Buy Now'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}